import React from 'react';
import { graphql } from 'gatsby';
import Layout from 'components/Layout';
import SEO from 'components/SEO';
import Hero from 'components/Hero';
import SliceZone from 'components/SliceZone';

export default ({ data }) => {
  const customer = data.prismic.customerByUID;
  const allProducts = data.prismic.allProductss.edges[0].node;

  if (!customer) {
    return null;
  }

  return (
    <Layout>
      <SEO
        title={customer.social_title || (customer.title && customer.title[0].text) || 'Customer'}
        description={customer.social_description}
        image={customer.social_image ? customer.social_image.url : null}
      />

      <Hero
        rubric={customer.hero_intro}
        heading={customer.hero_heading}
        content={customer.hero_content}
        image={customer.hero_image}
        illustration={customer.hero_illustration}
        buttons={customer.hero_button_destination && [
          {
            text: customer.hero_button_text || 'Get Started',
            destination: customer.hero_button_destination,
          }
        ]}
      />

      {customer.body &&
      <SliceZone
        body={customer.body}
        allProducts={allProducts}
        variant='customer'
      />
      }
    </Layout>
  );
};

export const query = graphql`
  query getCustomer($uid: String!) {
    prismic {
      customerByUID: customer(uid: $uid, lang: "en-us") {
        _meta {
          uid
        }
        title
        hero_intro
        hero_heading
        hero_content
        hero_image
        hero_illustration {
          ... on PRISMIC__FileLink {
            _linkType
            name
            size
            url
          }
        }
        hero_button_text
        hero_button_destination
        social_title
        social_description
        social_image
        no_follow
        body {
          ... on PRISMIC_CustomerBodyTout {
            type
            primary {
              content
              heading
              intro
            }
          }
          ... on PRISMIC_CustomerBodyContent_block {
            type
            primary {
              content
              heading
              intro
              image
              illustration {
                ... on PRISMIC__FileLink {
                  _linkType
                  url
                }
              }
            }
          }
          ... on PRISMIC_CustomerBodyContent_columns {
            type
            fields {
              content
              heading
              image
            }
          }
          ... on PRISMIC_CustomerBodyAccordion {
            type
            fields {
              content
              heading
              illustration {
                ... on PRISMIC__FileLink {
                  _linkType
                  url
                }
              }
              image
            }
            primary {
              content
              heading
              illustration {
                ... on PRISMIC__FileLink {
                  _linkType
                  url
                }
              }
              image
              intro
            }
          }
          ... on PRISMIC_CustomerBodyContent_list {
            type
            fields {
              additional_content
              content
              heading
              illustration {
                ... on PRISMIC__FileLink {
                  _linkType
                  url
                }
              }
              image
            }
            primary {
              content
              heading
              illustration {
                ... on PRISMIC__FileLink {
                  _linkType
                  url
                }
              }
              image
              intro
              is_numbered
            }
          }
          ... on PRISMIC_CustomerBodyCase_study {
            type
            primary {
              case_study_delay
            }
            fields {
              study {
                ... on PRISMIC_Case_study {
                  company
                  logo
                  quote
                  content
                  image
                  statistics {
                    label
                    value
                  }
                }
              }
            }
          }
          ... on PRISMIC_CustomerBodyTrapdoor {
            type
            primary {
              button_text
              destination
              heading
              intro
            }
          }
          ... on PRISMIC_CustomerBodyProduct_suite {
            type
            primary {
              heading
              content
            }
            fields {
              product {
                ... on PRISMIC_Product {
                  logo
                  name
                  logline
                  short_description
                  preview_image
                  preview_hover_image
                  _meta {
                    uid
                  }
                }
              }
            }
          }
          ... on PRISMIC_CustomerBodyPlayer {
            type
            primary {
              widget_name
              pubname
              plid
            }
          }
          ... on PRISMIC_CustomerBodyCustom_html {
            type
            primary {
              content
            }
          }
          ... on PRISMIC_CustomerBodyPartner_grid {
            type
            fields {
              logo
            }
          }
          ... on PRISMIC_CustomerBodyGetting_started {
            type
            primary {
              content 
              button_text
              destination
            }
            fields {
              heading
              text
            }
          }
        }
      }
      allProductss {
        edges {
          node {
            heading
            content
            products_list {
              product {
                ... on PRISMIC_Product {
                  logo
                  name
                  logline
                  short_description
                  preview_image
                  preview_hover_image
                  _meta {
                    uid
                  }
                }
              }
            }
            case_study_delay
          }
        }
      }
    }
  }
`;
